import { ApolloProvider } from "@apollo/client";
import { getApiClient } from "@src/api";
import config from "@src/config";
import { useCreateProfileMenuListener } from "@src/desktop";
import { useOrientationAdjust } from "@src/hooks/use-orientation-adjust";
import { queryClient } from "@src/query-client";
import { LoggerName, getLogger, setupLoggers } from "@src/utils/logConfig";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect } from "react";

export function DataLoaderProviders(props: { children: React.ReactNode }) {
	setupLoggers();

	const logger = getLogger(LoggerName.APP);
	const appVersion = config.appVersion;

	// Apply orientation adjustment fix
	useOrientationAdjust();

	// Global listener for native desktop menu triggers
	useCreateProfileMenuListener();

	// biome-ignore lint/correctness/useExhaustiveDependencies: side effect for logging
	useEffect(() => {
		logger.info("illumi client", appVersion);
	}, []);

	const client = getApiClient();
	return (
		<ApolloProvider client={client}>
			<QueryClientProvider client={queryClient}>
				{props.children}
				<ReactQueryDevtools />
			</QueryClientProvider>
		</ApolloProvider>
	);
}
